import { useQuery } from "@tanstack/react-query";
import type { ReportActionDescriptor } from "../../core";
import { useRuntime } from "../runtime/RuntimeContext";

// Fetch the print-menu lister for a (modelKey, mode, recordId) context.
// Disabled when modelKey is empty OR (in form mode) when recordId is missing,
// matching the backend's ReportsController.list_for_context semantics.
export function useReportActions(opts: {
    modelKey: string | undefined;
    mode: "form" | "list";
    recordId?: string;
    enabled?: boolean;
}) {
    const runtime = useRuntime();
    const { modelKey, mode, recordId } = opts;
    const isReady = Boolean(modelKey) && (mode === "list" || Boolean(recordId));
    const enabled = (opts.enabled ?? true) && isReady;
    return useQuery<ReportActionDescriptor[]>({
        queryKey: ["report-actions", modelKey, mode, recordId ?? ""],
        queryFn: () =>
            runtime.services.report.listForContext({
                modelKey: modelKey as string,
                mode,
                recordId,
            }),
        enabled,
        staleTime: 30_000,
    });
}
